export enum Region {
    Asia = "Asia",
    Europe = "Europe",
    USA = "USA",
    Germany = "Germany",
    Worldwide = "Worldwide"
}
